<template>
    <div style="display: flex">
        <SiderLayer />
        <main class="subpage usermap">
            <section class="title__content">
                <div class="subpage__inner">
                    <div class="flex justify-between">
                        <h2 class="title">내위치</h2>
                        <button type="button" class="button small black-outline" @click="onContents">작품별 보기</button>
                        <!-- <button type="button" class="button small primary" @click="onMoveStudyRecords">학습 기록 보기</button> -->
                    </div>
                </div>
            </section>
            <section class="subpage__content">
                <div class="subpage__inner">
                    <div class="dashboard">
                        <!-- <div class="panel__box gray">  -->
                        <div v-if="!noStudyData">
                            <!--//////// 1111_차트 ///////////////////////-->
                            <div class="boxRounded" style="background-color: #f7f7f7; padding: 4vmin">
                                <p class="mapTt30 textLayout">
                                    {{ userName }}님은 <span class="mapTt30" style="color: #8e43f0"> {{ curSP?.level }}레벨 {{ curSP?.lesson }}레슨</span>
                                </p>
                                <p class="mapTt33 textLayout">출발점 {{ startSP?.level }}레벨 {{ startSP?.lesson }}레슨</p>
                                <mapChart v-if="startSP && curSP" :startLevel="startSP.level" :startLesson="startSP.lesson" :lesson="curSP.lesson" :level="curSP.level" />
                            </div>

                            <!--//////// 2222_오늘학습 ///////////////////////-->
                            <h3 class="subtitle">오늘 학습</h3>
                            <div v-if="todayStudy?.todayLearningList?.length > 0">
                                <!-- <p class="mapTt30 textLayout">오늘 학습</p> -->
                                <StudyBox :topData="todayStudy" />
                            </div>
                            <!--//////// NoData ///////////////////////-->
                            <div v-if="noStudyData">
                                <div class="boxRounded" style="background-color: #f7f7f7">
                                    <mapChart :noStudyData="noStudyData" />
                                </div>
                                <div style="text-align: center; margin: 80px">
                                    <NoData :btnTitle="`학습 홈으로 이동`" />
                                </div>
                            </div>
                        </div>
                        <!-- </div> -->
                    </div>
                    <!-- <div class="mg_top_80 today"> -->
                    <!-- </div> -->
                </div>
                <div class="mg_top_80 pd_top_80 study">
                    <div class="subpage__inner">
                        <h3 class="mg_bottom_32 subtitle">학습기록</h3>

                        <!--//////// 3333_학습기록 ///////////////////////-->
                        <div v-if="!noStudyData" style="margin-top: 3vh; padding: 2vw; background-color: #fafafa">
                            <!-- <p class="mapTt30 textLayout">학습기록</p> -->
                            <StudyList :totalData="totalData" />
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </div>
</template>
<script setup>
import { onMounted, ref, computed, watch } from 'vue';
import SiderLayer from '@/components/layouts/sider/siderLayer.vue';
import Test1 from '@/views/testP/index.vue';

import StudyBox from '@/views/userMap/components/studyBox.vue';
import StudyList from '@/views/userMap/components/studyList.vue';
import NoData from '@/views/userMap/components/noData.vue';
import { getKnowledgeMap } from '@/api/modules/user_map.js';
import { getUserInfo } from '@/api/modules/mypage';
import mapChart from '@/components/chart/mapChart.vue';
import cqBtnVue from '@/components/quasar/cqBtn.vue';
import { useRouter } from 'vue-router';
import { GlobalStore } from '@/store';

const gStore = GlobalStore();
const router = useRouter();

const noStudyData = ref(false);
// watch(noStudyData, (nnn, ooo) => {
//     console.log('--noStudyData noStudyData--', nnn);
// });
const isDisableBtn = ref(false);
const totalData = ref([]);
const todayStudy = ref();
const startSP = ref(null);
const curSP = ref(null);

const userName = ref();
const setUserInfo = async () => {
    const res = await getUserInfo(gStore.token);
    if (res && res.status === 200) {
        // console.log('--setUserInfo setUserInfo--');
        userName.value = res.data.data.studentName;
    }
};

const setGraphData = (spInfo) => {
    // const total = 3 * 96;
    // startSP.value = (spInfo.orgSpLevel - 1) * 96 + spInfo.orgSpLesson;
    // startSP.value = Math.round((100 / total) * point);
    // curSP.value = (spInfo.currentLevel - 1) * 96 + spInfo.currentLesson;
    startSP.value = {
        level: spInfo.orgSpLevel,
        lesson: spInfo.orgSpLesson,
    };
    if (spInfo.currentLevel > 3) {
        // 4레벨 넘어가면 마지막 레벨레슨으로 표기
        curSP.value = {
            level: 3,
            lesson: 96,
        };
    } else {
        curSP.value = {
            level: spInfo.currentLevel,
            lesson: spInfo.currentLesson,
        };
    }
    // console.log('--startSP.value-- :', startSP.value);
    // console.log('--curSP.value-- :', curSP.value);
};
const setStudyData = async () => {
    const resMap = await getKnowledgeMap(gStore.token);
    // console.log('--resMap-- :', resMap);
    if (resMap)
        if (resMap.status === 200) {
            //No 오늘학습
            noStudyData.value = resMap.data.data.list.length < 1;
            // console.log('-- resMap.data.data.list.length -- :', resMap.data.data.list.length);

            // 오늘학습
            todayStudy.value = structuredClone(resMap.data.data.todayLearning);
            // 그래프
            setGraphData(resMap.data.data.spInfo);

            // 정렬
            totalData.value = resMap.data.data.list
                .map((e) => {
                    return { ...e, date: Number(e.date.replaceAll('.', '')) };
                })
                .sort((a, b) => b.date - a.date)
                .map((e, i, arr) => {
                    // console.log('--totalData--e:', e);
                    const previous = arr[i - 1];
                    // const result = { ...e, date: previous && previous.date === e.date ? null : e.date.toString().slice(0, 4) + '.' + e.date.toString().slice(4, 6) + '.' + e.date.toString().slice(6, 8) };
                    // console.log('--totalData--result:', result);
                    // return result;
                    return { ...e, date: previous && previous === e.date ? null : e.date.toString().slice(0, 4) + '.' + e.date.toString().slice(4, 6) + '.' + e.date.toString().slice(6, 8) };
                });

            // .map((e,i)=>{
            // });
            // totalData.value = Object.keys(aa).map((key) => aa[key]);
        }
};

onMounted(() => {
    setUserInfo();
    setStudyData();
});

////////////////////////////----OnClick----////////////////////////////
const onContents = () => {
    isDisableBtn.value = true;
    router.push('/contents');
};
const onHome = () => {
    router.push('/learninghome');
};
</script>

<style scoped lang="scss">
.textLayout {
    margin: 0 2.5vmin;

    &.mapTt33 {
        margin: 0.83vmin 2.5vmin 1.33vmin;
    }
}
.roundedBtnOut {
    padding: 1.17vmin 3.33vmin;
    border-radius: 1.3vmin;
    border: 1px solid black;
    background-color: white;
}
.map__title {
    // margin-top: 2vmin;
    margin: 0;
}

.content__box {
    // margin-bottom: 6.42vmin;
    margin-bottom: 3.6vw;
}
.boxRounded {
    margin: 0;
}
</style>
